import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
// import { ValidateDriverDriverInfo } from './ValidateDriverDriverInfo';

@Injectable()
export class DataService_VppOperator {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	ManualLookup() {
		var postResult$ = new Subject();
		var url = "VPP3/ManualLookup";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
